import { RouteConfig } from 'vue-router';
import ConsultaParecer from '@/views/parecer/ConsultaParecer.vue';

const baseRouterLink = '/parecer';

const ParecerRoutes: RouteConfig[] = [
  {
    path: `${baseRouterLink}/consulta`,
    name: 'consulta-parecer',
    component: ConsultaParecer,
  },
  {
    path: `${baseRouterLink}/consulta-avancada`,
    name: 'consulta-parecer-avancada',
    component: ConsultaParecer,
    meta: { isPrivado: true },
  },
];

export default ParecerRoutes;
